import { render, staticRenderFns } from "./proxylong.vue?vue&type=template&id=20252bda&scoped=true&"
import script from "./proxylong.vue?vue&type=script&lang=js&"
export * from "./proxylong.vue?vue&type=script&lang=js&"
import style0 from "./proxylong.vue?vue&type=style&index=0&id=20252bda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20252bda",
  null
  
)

export default component.exports